module.exports = __webpack_public_path__ + "img/RAIN_bg.55e849fb.png";